export default "__VITE_ASSET__D$lbpQdT__"